import { Box } from '@mui/material';
import { WidgetSelector, WidgetOption } from './WidgetSelector';
import { ProbabilityDistributionWidget } from './ProbabilityDistributionWidget';
import { BackpressureDistributionWidget } from './BackpressureDistributionWidget';
import { PositionsDistributionWidget } from './PositionsDistributionWidget';

type SetDefinition = Models.SetsPlayground.SetDefinition;
type SetDistribution = Models.SetsPlayground.SetDistribution;
type DistType = SetDistribution['type'];

interface Props {
    index: number;
    set: SetDefinition;
    onChangeDistribution: (index: number, dist: SetDistribution) => void;
}

export const DistributionWidgetContainer = ({ index, set, onChangeDistribution }: Props): JSX.Element => {
    const { distribution } = set;
    const selected = distribution.type;

    const distributionWidgets: WidgetOption<SetDistribution>[] = [
        ProbabilityDistributionWidget as WidgetOption<SetDistribution>,
        BackpressureDistributionWidget as WidgetOption<SetDistribution>,
        PositionsDistributionWidget as WidgetOption<SetDistribution>,
    ];

    const handleWidgetChange = (value: string): void => {
        const nextType = value as DistType;

        if (nextType !== distribution.type) {
            const widget = distributionWidgets.find((w) => w.value === nextType);

            if (widget?.getDefaultValue) {
                const defaultValue = widget.getDefaultValue();

                onChangeDistribution(index, defaultValue);
            }
        }
    };

    const handleDistributionChange = (newDistribution: SetDistribution): void => {
        onChangeDistribution(index, newDistribution);
    };

    return (
        <Box>
            <WidgetSelector
                label="Distribution Type"
                selected={selected}
                widgets={distributionWidgets}
                widgetValue={distribution}
                onWidgetChange={handleWidgetChange}
                onWidgetValueChange={handleDistributionChange}
            />
        </Box>
    );
};
